'use strict';

module.exports = function () {
    $(document).ready(function () {
        var lensValue = $('.first-lens-marking').data('value');
        var lensId = '#' + lensValue;
        $(lensId).removeClass('d-none');

        var frameValue = $('.first-frame-marking').data('value');
        var frameId = '#' + frameValue;
        $(frameId).removeClass('d-none');
    });

    $('.lens-column').hover(
        function () {
            var value = $(this).data('value');
            $('.lens-markings-list-description').addClass('d-none');
            var id = '#' + value;
            $(id).removeClass('d-none');
        }
    );

    $('.frame-column').hover(
        function () {
            var value = $(this).data('value');
            $('.frame-markings-list-description').addClass('d-none');
            var id = '#' + value;
            $(id).removeClass('d-none');
        }
    );
};
